// extracted by mini-css-extract-plugin
export default {"productGrid":"K0-z","centerLink":"L0-z","productSection":"M0-z","item":"N0-z","ctaButton":"O0-z"};